import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../ReactApp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import Loader from "../../Loader";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

function ReservationRow(props) {
  const { user } = useAuth();

  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [loadingOffer, setLoadingOffer] = useState(false);

  useEffect(() => {
    ReactModal.setAppElement("#root");
  }, []);

  const [datesSorted, setDatesSorted] = useState(false);

  useEffect(() => {
    afficher_dates_consecutives(props);
  }, [props]);

  const afficher_dates_consecutives = (props) => {
    let result = "";

    const dates = props.item.dates;
    const nbDates = dates.length;
    dates.sort(); // Tri pour faciliter le parcours
    let dateStart = dates[0];
    let dateEnd = dates[0];

    for (let i = 1; i < nbDates; i++) {
      if (
        dates[i] ===
        new Date(new Date(dateEnd).setDate(new Date(dateEnd).getDate() + 1))
          .toISOString()
          .substring(0, 10)
      ) {
        dateEnd = dates[i];
      } else {
        if (dateStart === dateEnd) {
          const formattedDateStart = new Date(dateStart);
          result += formattedDateStart.toLocaleDateString("fr") + ", ";
        } else {
          const formattedDateStart = new Date(dateStart);
          const formattedDateEnd = new Date(dateEnd);
          result +=
            "Du " +
            formattedDateStart.toLocaleDateString("fr") +
            " au " +
            formattedDateEnd.toLocaleDateString("fr") +
            ", ";
        }
        dateStart = dates[i];
        dateEnd = dates[i];
      }
    }

    if (dateStart === dateEnd) {
      const formattedDateStart = new Date(dateStart);
      result += formattedDateStart.toLocaleDateString("fr") + ", ";
    } else {
      const formattedDateStart = new Date(dateStart);
      const formattedDateEnd = new Date(dateEnd);
      result +=
        "Du " +
        formattedDateStart.toLocaleDateString("fr") +
        " au " +
        formattedDateEnd.toLocaleDateString("fr") +
        ", ";
    }

    if (result.endsWith(", ")) {
      result = result.slice(0, -2); // Suppression de la virgule et de l'espace
    }

    setDatesSorted(result);
  };

  const changeStatus = (status) => {
    setLoadingOffer(true);

    props.updateStatusReservation(props.item.id, status);
    setShowModal(false);

    setLoadingOffer(false);
  };

  const handleCreateConversation = (resa, user) => {
    let params = {
      id_reservation: resa.id,
      id_user: user._id,
    };

    axios
      .post(process.env.REACT_APP_API_URL + "/v1/create-conversation", params)
      .then((response) => {
        if (response.data) {
          let blockToDisplay = "messagerie";
          navigate("/profil", {
            state: { blockToDisplay: blockToDisplay, conv: response.data },
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <tr>
        <td>{props.item.created_at}</td>
        <td>{props.item.customer}</td>
        <td>{datesSorted}</td>
        {props.item.price_offer != null ? (
          <td>
            {props.item.price_offer}€{" "}
            <strike>{props.item.price * props.item.dates.length}€</strike>
          </td>
        ) : (
          <td>{props.item.price * props.item.dates.length}€</td>
        )}

        {user.role === "betonnier" ? (
          <td>
            <div className={"btn-statut btn-statut-" + props.item.status}>
              {(() => {
                switch (props.item.status) {
                  case "accepted":
                    return "Accepté";
                  case "refused":
                    return "Refusé";
                  case "pending":
                    return "En attente";
                  default:
                    return "Statut inconnu";
                }
              })()}
            </div>
          </td>
        ) : props.isArchive ? (
          <td className={props.item.status}>{props.item.status}</td>
        ) : (
          <td>
            <button
              className="btn btn-outline-primary"
              onClick={() => changeStatus("accepted")}
            >
              &#x2714;
            </button>
            <button
              className="btn btn-outline-danger"
              onClick={() => changeStatus("refused")}
            >
              &#x2716;
            </button>
          </td>
        )}
        <td>
          <button
            className="btn btn-message"
            onClick={() => handleCreateConversation(props.item, user)}
          >
            <FontAwesomeIcon icon={faEnvelope} />{" "}
            {loadingOffer ? <Loader /> : ""}
          </button>
        </td>
        {user.role === "betonnier" ? (
          <td>
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={() => changeStatus("refused")}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </td>
        ) : (
          ""
        )}
      </tr>
    </>
  );
}

export default ReservationRow;
